export default "__VITE_ASSET__8xxt1a0c__"